// extracted by mini-css-extract-plugin
module.exports = {"alert":"iJ","alertIcon":"iK","formContainer":"iL","formContainerInner":"iM","successIcon":"iN","footer":"iO","footerItem":"iP"};